module.exports = __webpack_public_path__ + "static/img/down_btn12.90c1358.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/down_btn12.png
// module id = bVsI
// module chunks = 4